import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

// import { ReactComponent as RatesIcon } from "assets/images/icons/Rates.svg";
import { ReactComponent as CalculatorIcon } from "assets/images/icons/Calculator.svg";
import { ReactComponent as ChartIcon } from "assets/images/icons/Chart.svg";
import { ReactComponent as FileInvoiceDollarIcon } from "assets/images/icons/FileInvoiceDollar.svg";
import { ReactComponent as HomeIcon } from "assets/images/icons/Home.svg";
import { ReactComponent as ShipIcon } from "assets/images/icons/Ship.svg";
import usePermissions from "hooks/usePermissions";
import useToken from "hooks/useToken";
import testIds from "constants/testIds";
import { IPermissionProps, IItemProps } from "components/molecules/Navigation/interface/sidebar";
import MenuItem from "../common/MenuItem";

interface IProviderMenuItemsProps {
  handleCloseNav: () => void;
}

const ProviderMenuItems = function ({ handleCloseNav }: IProviderMenuItemsProps) {
  const intl = useIntl();
  const { getPermissions, clearPermissions } = usePermissions();
  const { token } = useToken();
  const [userPermissions, setUserPermissions] = useState<IPermissionProps>({});
  const permissions = getPermissions();

  useEffect(() => {
    if (token && permissions) {
      setUserPermissions(JSON.parse(permissions).menu_items);
    } else clearPermissions();
  }, [token, permissions]);

  const navigationTop: IItemProps[] = [
    {
      eventKey: "1",
      id: "dashboard",
      icon: <HomeIcon />,
      label: intl.formatMessage({ id: "components.molecules.navigation.dashboard", defaultMessage: "Dashboard" }),
      parentUrl: "/",
      to: "/",
      enabled: true,
      testId: testIds.MENU_DASHBOARD_BUTTON,
    },
    // Commented out for now. Providers don't use this often so we are removing it. If we need it back, uncomment this and the rates icon import above.
    // {
    //   eventKey: "2",
    //   id: "rates",
    //   icon: <RatesIcon />,
    //   label: intl.formatMessage({
    //     id: "general.rates",
    //     defaultMessage: "Rates",
    //   }),
    //   parentUrl: "/rates",
    //   to: "/rates",
    //   enabled: userPermissions.view_tenders,
    //   testId: testIds.MENU_RATES_BUTTON,
    // },
    {
      eventKey: "3",
      id: "quote_requests",
      icon: <CalculatorIcon />,
      label: intl.formatMessage({
        id: "components.molecules.navigation.quoteRequests",
        defaultMessage: "Quote Requests",
      }),
      parentUrl: "/quote-requests",
      to: "/quote-requests?display_status=active",
      enabled: userPermissions.view_quote_requests,
      testId: testIds.MENU_QUOTE_REQUESTS_BUTTON,
    },
    {
      eventKey: "4",
      id: "shipments",
      icon: <ShipIcon />,
      label: intl.formatMessage({
        id: "general.shipments",
        defaultMessage: "Shipments",
      }),
      parentUrl: "/shipments",
      to: "/shipments",
      enabled: userPermissions.view_shipments,
      testId: testIds.MENU_SHIPMENTS_BUTTON,
    },
    {
      eventKey: "5",
      id: "invoices",
      icon: <FileInvoiceDollarIcon />,
      label: intl.formatMessage({
        id: "general.invoices",
        defaultMessage: "Invoices",
      }),
      parentUrl: "/invoices",
      to: "/invoices",
      testId: testIds.MENU_INVOICES_BUTTON,
      enabled: userPermissions.view_invoices,
    },
    {
      eventKey: "6",
      id: "analytics",
      icon: <ChartIcon />,
      label: intl.formatMessage({
        id: "components.molecules.navigation.analytics",
        defaultMessage: "Analytics",
      }),
      parentUrl: "/analytics",
      to: "/analytics",
      enabled: userPermissions.view_analytics,
      testId: testIds.MENU_ANALYTICS_BUTTON,
    },
  ];

  return (
    <div className="menu-item-center w-100">
      {navigationTop.map((item) => (
        <MenuItem item={item} key={item.id} closeNav={handleCloseNav} testId={item.testId} />
      ))}
    </div>
  );
};

export default ProviderMenuItems;
